import React, { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

//devextreem
import { Popup } from 'devextreme-react/popup';

import ModalFooter from 'components/appModalFooter';
import { Button, Tooltip } from 'devextreme-react';

import { RootStore } from 'bus/configureStore';
import { shiftClose, shiftOpen } from 'bus/shift/actions';

const ModalConfirmShift: FC = () => {
  const dispatch = useDispatch();
  const shift = useSelector((store: RootStore) => store.shift);
  const [visibleShift, setVisibleShift] = useState(false);

  const [visible, setVisible] = useState<boolean>(false);

  const handleSubmit = (e: any) => {
    e.preventDefault && e.preventDefault();
    if (shift.shiftCurrent.data) {
      dispatch(shiftClose.async());
    }

    if (!shift.shiftCurrent.data) {
      dispatch(shiftOpen.async());
    }

    setVisible(false);
  };

  const toggleDefault = () => setVisibleShift(!visibleShift);

  return (
    <>
      <Tooltip target="#shift" position="bottom" visible={visibleShift}>
        <div>{shift.shiftCurrent.data ? 'Завершить текущую смену' : 'Начать новую смену'}</div>
      </Tooltip>
      <span id="shift" onMouseEnter={toggleDefault} onMouseLeave={toggleDefault}>
        <Button
          text={shift.shiftCurrent.data ? 'Закрыть смену' : 'Открыть смену'}
          type={shift.shiftCurrent.data ? 'danger' : 'success'}
          onClick={() => setVisible(true)}
          className="mr-2"
        />
      </span>
      <Popup
        visible={visible}
        onHiding={() => setVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Подтвердите действие"
        width={400}
        height={160}
      >
        <div className="modal-block">
          <form onSubmit={handleSubmit}>
            <div className="modal-block__content">
              Вы действительно хотите {shift.shiftCurrent.data ? 'закрыть' : 'открыть'} смену?
            </div>

            <ModalFooter
              useSubmitBehavior={false}
              handleSubmit={handleSubmit}
              hideModal={() => setVisible(false)}
              textConfirm={shift.shiftCurrent.data ? 'Закрыть смену' : 'Открыть смену'}
              typeConfirm={shift.shiftCurrent.data ? 'danger' : 'success'}
            />
          </form>
        </div>
      </Popup>
    </>
  );
};

export default ModalConfirmShift;
